import { computed, unref } from 'vue'
import { createListQuery, toUpperCase } from '../utils'
import { createSharedComposable } from '@vueuse/core'
import { useCountries } from '@/composables/useCountries'

export const useCountry = createSharedComposable(() => {
    const { countries } = useCountries()

    const countriesList = computed(() => {
        return unref(countries).map(({ name, iso, region }) => ({
            label: name,
            value: iso,
            region: region
        }))
    })

    return createListQuery('country', countriesList, {
        normalize: toUpperCase,
        defaultValue: undefined
    })
})
